module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5620/img/templates-homepage/customize-website-icon.svg"